import React, { useEffect, useState } from "react";
import { Table, Button, Form, Input, Modal, message, Select } from "antd";
import RenderTxt from "../../../../components/renderTxt";
import { stationApi } from "@api/newApi";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
export default ({ processUnitId }) => {
  const userInfo = sessionStorage.getItem("userInfo")
    ? JSON.parse(sessionStorage.getItem("userInfo"))
    : {};

  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [attrType, setAttrType] = useState(2);
  const [title, setTitle] = useState("");
  const [processAttrId, setProcessAttrId] = useState();
  const columns = [
    {
      title: "属性名称",
      dataIndex: "attrName",
      align: "center",
      key: "attrName",
      width: 160,
      ellipsis: {
        showTitle: false,
      },
      render: (_t) => RenderTxt(_t, 20),
    },
    {
      title: "属性编码",
      dataIndex: "attrCode",
      align: "center",
      key: "attrCode",
      width: 160,
      ellipsis: {
        showTitle: false,
      },
      render: (_t) => RenderTxt(_t, 20),
    },
    {
      title: "属性值",
      dataIndex: "value",
      align: "center",
      key: "value",
      width: 160,
      ellipsis: {
        showTitle: false,
      },
      render: (_t) => RenderTxt(_t, 20),
    },
    {
      title: "单位",
      dataIndex: "unit",
      align: "center",
      key: "unit",
      width: 100,
      ellipsis: {
        showTitle: false,
      },
      render: (_t) => RenderTxt(_t, 20),
    },
    {
      title: "重要显示",
      dataIndex: "isMainShow",
      align: "center",
      key: "isMainShow",
      width: 100,
      ellipsis: {
        showTitle: false,
      },
      render: (_t) => (_t == 1 ? "是" : "否"),
    },
    {
      title: "显示名称",
      dataIndex: "isShowName",
      align: "center",
      key: "isShowName",
      width: 100,
      ellipsis: {
        showTitle: false,
      },
      render: (_t) => (_t == 1 ? "是" : "否"),
    },
    {
      width: 200,
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button type="primary" onClick={() => editRecord(obj)}>
              编辑
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={() => delRecord(obj.id)}
              danger
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (processUnitId) {
      getProcessUnitAttr();
    }
  }, [processUnitId]);

  const getProcessUnitAttr = () => {
    setLoading(true);
    stationApi.findUnitDisplayDetail(stationId, processUnitId).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { diyAttrList } = res.data;
      diyAttrList.forEach((item) => {
        item.key = item.id;
      });
      setDataSource(diyAttrList);
    });
  };

  const addAttr = () => {
    if (!processUnitId) return message.error("请选择工艺单元");
    setVisible(true);
    setTitle("新增属性");
  };

  const editRecord = (record) => {
    setVisible(true);
    setTitle("修改属性");
    const {
      type,
      attrName,
      attrCode,
      enumMap,
      id,
      unit,
      isMainShow,
      isShowName,
    } = record;
    setAttrType(type);
    setProcessAttrId(id);
    const params = { type, attrName, attrCode, unit, isMainShow, isShowName };
    const enumMapList = [];
    if (type == 3) {
      enumMap.split(",").map((item, index) => {
        if (index % 2 == 0 && item) {
          enumMapList.push({
            key: item,
            value: enumMap.split(",")[index + 1],
          });
        }
      });
      params.enumMapList = enumMapList;
    }
    form.setFieldsValue({ ...params });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        stationApi.deleteUnitAttrById(id).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          getProcessUnitAttr();
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const saveAttr = () => {
    form.validateFields().then((values) => {
      const params = {
        ...values,
        stationId,
        processunitId: processUnitId,
      };
      if (values.type == 3) {
        let enumMap = "";
        values.enumMapList.map((item) => {
          if (item.key && item.value) {
            enumMap += item.key + "," + item.value + ",";
          }
        });
        enumMap = enumMap.substring(0, enumMap.lastIndexOf(","));
        params.enumMap = enumMap;
        delete params.enumMapList;
      }
      if (processAttrId) {
        setConfirmLoading(true);
        stationApi
          .updateProcessUnitAttr({ ...params, id: processAttrId })
          .then((res) => {
            setConfirmLoading(false);
            if (res.status !== "0") return;
            message.success("修改成功");
            cancelAttr();
            getProcessUnitAttr();
          });
      } else {
        setConfirmLoading(true);
        stationApi.addProcessUnitAttr(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancelAttr();
          getProcessUnitAttr();
        });
      }
    });
  };

  const cancelAttr = () => {
    setVisible(false);
    setTitle("");
    setAttrType(2);
    setProcessAttrId(null);
    form.resetFields();
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Button type="primary" style={{ marginBottom: 20 }} onClick={addAttr}>
        新增
      </Button>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        pagination={false}
        scroll={{
          x: columns.reduce((a, b) => a + b.width, 0),
        }}
      />
      {visible && (
        <Modal
          title={title}
          open={visible}
          onCancel={cancelAttr}
          onOk={saveAttr}
          width={800}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="属性名称"
              name="attrName"
              rules={[{ required: true, message: "请输入属性名称" }]}
            >
              <Input placeholder={"请输入属性名称"} />
            </Form.Item>
            <Form.Item
              label="属性编码"
              name="attrCode"
              rules={[{ required: true, message: "请输入属性编码" }]}
            >
              <Input placeholder={"请输入属性编码"} />
            </Form.Item>
            <Form.Item
              label="单位"
              name="unit"
              rules={[{ required: false, message: "请输入单位" }]}
            >
              <Input placeholder={"请输入单位"} />
            </Form.Item>
            <Form.Item
              label="重要显示"
              name="isMainShow"
              rules={[{ required: true, message: "请选择重要显示" }]}
            >
              <Select placeholder="请选择重要显示">
                <Select.Option value={0}>否</Select.Option>
                <Select.Option value={1}>是</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="显示名称"
              name="isShowName"
              rules={[{ required: true, message: "请选择是否显示名称" }]}
            >
              <Select placeholder="请选择是否显示名称">
                <Select.Option value={0}>否</Select.Option>
                <Select.Option value={1}>是</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="属性类型"
              name="type"
              rules={[{ required: true, message: "请选择属性类型" }]}
            >
              <Select
                placeholder="请选择属性类型"
                onChange={(e) => setAttrType(e)}
              >
                <Select.Option value={1}>布尔类型</Select.Option>
                <Select.Option value={2}>字符串</Select.Option>
                <Select.Option value={3}>枚举</Select.Option>
              </Select>
            </Form.Item>
            {attrType == 3 && (
              <Form.Item label="枚举列表">
                <Form.List name="enumMapList" label="枚举列表">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field) => (
                        <div key={field.key}>
                          <Form.Item
                            label="枚举Key"
                            name={[field.name, "key"]}
                            rules={[
                              { required: true, message: "请填写枚举Key!" },
                            ]}
                          >
                            <Input placeholder={"请填写枚举Key"} />
                          </Form.Item>
                          <Form.Item
                            label="枚举Value"
                            name={[field.name, "value"]}
                            rules={[
                              { required: true, message: "请填写枚举Value!" },
                            ]}
                          >
                            <Input placeholder={"请填写枚举Value"} />
                          </Form.Item>
                          <Form.Item>
                            {fields.length > 1 && (
                              <Button
                                type="dashed"
                                onClick={() => remove(field.name)}
                              >
                                移除
                              </Button>
                            )}
                          </Form.Item>
                        </div>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={add}>
                          添加
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Form.Item>
            )}
          </Form>
        </Modal>
      )}
    </div>
  );
};
